{
  "common.close": "关闭",
  "common.athleteFallback": "运动员 {id}",
  "splash.title": "{app} — 动态活动可视化",
  "splash.tagline": "把你的 Strava&nbsp;数据变成动态地图",
  "splash.demo": "演示",
  "tab.query.title": "{name} 的地图",
  "tab.query.heading": "活动查询:",
  "tab.query.optDays": "最近天数",
  "tab.query.optActivities": "最近活动数",
  "tab.query.optIds": "活动 ID",
  "tab.query.optDates": "日期范围",
  "tab.query.idsPlaceholder": "在此输入活动 ID",
  "tab.query.after": "起始:",
  "tab.query.before": "结束:",
  "tab.query.autozoom": "导入后自动缩放到查询范围 <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> 查询",
  "tab.query.createAccount": "请创建账号或登录。",
  "tab.query.sports": "运动：",
  "tab.query.allSports": "所有运动",
  "tab.query.sportsExcept": "全部，除了",
  "tab.query.sportsNone": "无",
  "tab.query.loadingSports": "正在加载运动…",
  "tab.query.sportsFailed": "无法加载此地图的运动",
  "tab.query.noSports": "还没有活动",
  "tab.activities.title": "已显示的活动",
  "tab.activities.clearSelection": "清除选择",
  "tab.activities.renderSelected": "显示所选",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> 缩放到所选范围",
  "tab.controls.title": "图层设置",
  "tab.controls.timescale": "时间尺度 <i>&tau;</i>",
  "tab.controls.timescaleHint": "播放速度",
  "tab.controls.period": "周期 <i>T</i>",
  "tab.controls.periodHint": "实际时间 ~ 模型时间",
  "tab.controls.dotSize": "圆点大小",
  "tab.controls.pathWidth": "轨迹宽度",
  "tab.controls.pathWidthHint": "设为 0 可隐藏轨迹",
  "tab.controls.colors": "配色",
  "tab.controls.colorsHint": "旋转调色板",
  "tab.controls.shadows": "阴影",
  "tab.profile.loginTitle": "登录",
  "tab.profile.anonNote": "使用 Strava 登录即可查看自己的活动，并管理你的 Heatflask 账号。",
  "tab.profile.loginLink": "使用 Strava 登录",
  "tab.profile.editOnStrava": "在 Strava 上编辑个人资料",
  "tab.profile.indexNote": "我们会为你的活动摘要建立索引，以便快速访问。",
  "tab.profile.viewIndex": "查看索引",
  "tab.profile.sharedMaps": "共享地图",
  "tab.profile.sharedMapsNote": "关闭：只有你能在 Heatflask 中看到自己的活动。开启：任何拿到你地图链接的人都能看到你在 Strava 上公开的活动。私密活动始终只有你能看到。 <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">隐私如何运作</a>",
  "tab.profile.logout": "退出登录",
  "tab.profile.deleteAccount": "删除账号",
  "tab.profile.deleteConfirm": "要删除你的 Heatflask 账号吗?\n\n这会移除已索引的活动，并撤销 Heatflask 对你 Strava 数据的访问权限。此操作无法撤销。",
  "tab.profile.languageHeading": "语言",
  "tab.profile.languageAuto": "自动",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">欢迎帮我们修正或添加翻译！</a>",
  "tab.profile.unitsHeading": "单位",
  "tab.profile.unitsAuto": "自动",
  "tab.profile.unitsMetric": "公制 (km, m)",
  "tab.profile.unitsImperial": "英制 (mi, ft)",
  "tab.profile.textSizeHeading": "文字大小",
  "tab.profile.textSmaller": "更小",
  "tab.profile.textReset": "标准",
  "tab.profile.textLarger": "更大",
  "tab.profile.mapDefaultsHeading": "地图默认设置",
  "tab.profile.mapDefaultsNote": "打开链接未指定样式的地图时，使用此底图、地形和图层设置。你分享的链接仍会完全显示你所看到的内容。",
  "tab.profile.mapDefaultsSave": "保存为我的默认设置",
  "tab.profile.mapDefaultsForget": "清除",
  "tab.info.title": "信息",
  "tab.info.controlsHeading": "操作",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + 拖动",
  "tab.info.shiftDragDesc": "框选活动。在触摸屏上，先点按 <i class=\"hf-object-group\"></i>，再用单指拖动。最后选中的活动会显示详情，活动列表也会滚动到该项。",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + 拖动",
  "tab.info.ctrlDragDesc": "以 3D 方式旋转和倾斜地图，也可用双指操作",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "打开或关闭侧边栏",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "上一个或下一个侧边栏标签",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "关闭侧边栏",
  "tab.info.liveUrlHeading": "实时 URL",
  "tab.info.liveUrlDesc": "地图视角和动画设置都保存在页面 URL 中，因此你分享给谁，对方看到的就是同一个画面。",
  "tab.info.videoHeading": "导出视频",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> 按钮可将动画录制为 MP4：点按它，把方框调整到你想要的地图范围，再次点按即可录制。录制的是完整的一个动画周期，因此视频可以无缝循环；若一个周期超过 {max} 秒（Strava 允许的最长视频），则会在 {max} 秒处截断。",
  "tab.info.contributeHeading": "参与贡献",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> 在 GitHub 上赞助",
  "tab.info.contactsHeading": "联系方式",
  "map.basemapAndTerrain": "底图与地形",
  "map.pauseAnimation": "暂停动画",
  "map.resumeAnimation": "继续动画",
  "capture.record": "录制视频（一个周期 {period} 秒）",
  "capture.recordTruncated": "录制视频（一个周期 {period} 秒；只录制前 {max} 秒）",
  "capture.recordArea": "录制方框内的区域",
  "capture.stop": "停止录制",
  "capture.selectionTooSmall": "所选范围太小",
  "capture.saved": "已保存 {name}（{size}）",
  "capture.cancelled": "已取消录制",
  "capture.failed": "录制失败: {error}",
  "capture.loadingEncoder": "正在加载编码器…",
  "capture.waitingForMap": "正在等待地图加载…",
  "capture.encoding": "正在编码… {percent}%",
  "capture.finalizing": "正在收尾…",
  "share.title": "分享此地图的链接",
  "share.copied": "链接已复制",
  "share.copiedUnshared": "链接已复制，但你的地图未共享，其他人无法打开。开启“共享地图”即可更改。",
  "share.unshared": "你的地图未共享，其他人无法打开此链接。开启“共享地图”即可更改。",
  "share.copyThis": "复制此链接：",
  "update.available": "Heatflask 有新版本可用。",
  "update.reload": "重新加载",
  "import.title": "正在导入",
  "import.stop": "停止",
  "import.stopping": "正在停止…",
  "import.contacting": "正在连接 Strava…",
  "import.countOf": "{total} 项中的 {received} 项",
  "import.count": "{received} 项活动",
  "import.waitStrava": "因 Strava 下载限制暂停至 {time}。请保持此页面打开；刷新不会更快。",
  "import.waitRationed": "今天的快速下载额度已用完。其余部分将于 {time} 较慢地继续。请保持此页面打开。",
  "import.dailyLimit": "Strava 每日下载上限已用完。请在 {time} 之后再试。",
  "import.dailyRationed": "你今天的 Strava 下载份额已用完。请在 {time} 之后再试。",
  "import.noActivitiesYet": "你的 Strava 账户还没有任何活动。在 Strava 上记录或上传一项活动后，它就会显示在这里。",
  "table.noActivities": "没有活动",
  "table.untitled": "(无标题)",
  "activities.pageTitle": "{app} — 活动索引",
  "activities.heading": "活动索引",
  "activities.fetching": "正在获取活动...",
  "activities.rateLimit": "已达到 Strava 的速率限制；将于 {time} 继续",
  "activities.noData": "抱歉，没有数据 &#128577;",
  "activities.colServerCache": "轨迹已缓存在服务器（Mongo）",
  "activities.colBrowserCache": "轨迹已缓存在此浏览器",
  "activities.cachedServer": "{id} 的轨迹已缓存在服务器",
  "activities.notCachedServer": "{id} 的轨迹未缓存在服务器",
  "activities.cachedBrowser": "{id} 的轨迹已缓存在此浏览器",
  "activities.notCachedBrowser": "{id} 的轨迹未缓存在此浏览器",
  "sport.AlpineSki": "高山滑雪",
  "sport.BackcountrySki": "野雪滑雪",
  "sport.Badminton": "羽毛球",
  "sport.Basketball": "篮球",
  "sport.Canoeing": "划独木舟",
  "sport.Cricket": "板球",
  "sport.Crossfit": "CrossFit",
  "sport.Dance": "舞蹈",
  "sport.EBikeRide": "电动自行车骑行",
  "sport.Elliptical": "椭圆机",
  "sport.EMountainBikeRide": "电动山地车骑行",
  "sport.Golf": "高尔夫",
  "sport.GravelRide": "砾石路骑行",
  "sport.Handcycle": "手摇车",
  "sport.HighIntensityIntervalTraining": "高强度间歇训练",
  "sport.Hike": "徒步",
  "sport.IceSkate": "滑冰",
  "sport.InlineSkate": "轮滑",
  "sport.Kayaking": "皮划艇",
  "sport.Kitesurf": "风筝冲浪",
  "sport.MountainBikeRide": "山地车骑行",
  "sport.NordicSki": "越野滑雪",
  "sport.Padel": "板式网球",
  "sport.PhysicalTherapy": "物理治疗",
  "sport.Pickleball": "匹克球",
  "sport.Pilates": "普拉提",
  "sport.Racquetball": "壁球（美式）",
  "sport.Ride": "骑行",
  "sport.RockClimbing": "攀岩",
  "sport.RollerSki": "滑轮滑雪",
  "sport.Rowing": "划船",
  "sport.Run": "跑步",
  "sport.Sail": "帆船",
  "sport.Skateboard": "滑板",
  "sport.Snowboard": "单板滑雪",
  "sport.Snowshoe": "雪鞋行走",
  "sport.Soccer": "足球",
  "sport.Squash": "壁球",
  "sport.StairStepper": "踏步机",
  "sport.StandUpPaddling": "桨板",
  "sport.Surfing": "冲浪",
  "sport.Swim": "游泳",
  "sport.TableTennis": "乒乓球",
  "sport.Tennis": "网球",
  "sport.TrailRun": "越野跑",
  "sport.Velomobile": "人力车",
  "sport.VirtualRide": "虚拟骑行",
  "sport.VirtualRow": "虚拟划船",
  "sport.VirtualRun": "虚拟跑步",
  "sport.Volleyball": "排球",
  "sport.Walk": "步行",
  "sport.WeightTraining": "力量训练",
  "sport.Wheelchair": "轮椅",
  "sport.Windsurf": "帆板",
  "sport.Workout": "锻炼",
  "sport.Yoga": "瑜伽"
}
